/* eslint-disable jira/filename-case */
import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('enable_cfo_recommendations_m1', 'value', false);
	},
};
